import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import en from './en'
import es from './es'
import fr from './fr'
import it from './it'
import pt from './pt'
import nl from './nl'
import ru from './ru'
import pl from './pl'
import sv from './sv'

const savedLocale = localStorage.getItem('locale') || 'zh-CN'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    en,
    es,
    fr,
    it,
    pt,
    nl,
    ru,
    pl,
    sv,
  },
})

export default i18n
export { useI18n } from 'vue-i18n'
